// Helper condivisi per l'UX dei form: autofocus affidabile su mobile e
// classi di stato campo (da-compilare vs compilato). Centralizzati qui per
// coerenza tra editor alimenti, ricette ed etichette.

/**
 * Mette il focus su un IonInput aprendo la tastiera mobile.
 * Va chiamato dall'evento `onDidPresent` dell'IonModal: Ionic monta l'input
 * solo dopo il present, e su Android/iOS la tastiera si apre solo se
 * `setFocus()` parte in un task successivo (doppio rAF).
 */
export function focusInput(
  el: HTMLIonInputElement | null | undefined,
  opts?: { select?: boolean },
): void {
  if (!el) return;
  requestAnimationFrame(() => requestAnimationFrame(() => {
    void el.setFocus();
    // Con `select` evidenzia il testo già presente (es. nome "Copia di …"
    // pre-compilato dalla duplicazione ricetta) così l'utente lo sovrascrive
    // digitando, senza doverlo cancellare a mano.
    if (opts?.select) {
      void el.getInputElement().then((native) => {
        try { native?.select(); } catch { /* input non ancora montato: noop */ }
      });
    }
  }));
}

/** Classe per ion-item / wrapper: ambra pulsante se vuoto, verde se pieno. */
export const fieldClass = (filled: boolean): string =>
  filled ? 'te-field-ok' : 'te-field-missing';

/** Variante per le card custom (div bianchi con stile inline). */
export const cardClass = (filled: boolean): string =>
  filled ? 'te-card-ok' : 'te-card-missing';
